// cookies封装
import Cookies from 'js-cookie'
class Keys {
    static languageKey = 'vue3-typescript-admin-languageKey'
}

export default Keys
export const getLanguage = () => Cookies.get(Keys.languageKey)
export const setLanguage = (language: string) => Cookies.set(Keys.languageKey, language)
